module.exports = "<span ng-class=\"{ 'version-danger-text': footerVersionsCompatible == false }\" ng-if=\"footerConsoleVersion && footerCoreVersion\"> (Console <strong>v{{ footerConsoleVersion }}</strong> | Core <strong>v{{ footerCoreVersion }}</strong>) </span>";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/directives/footer-version.html
// module id = 971
// module chunks = 0